import axios from 'axios';
import Cookies from 'js-cookie';

const { apiHost = '' } = window.chatwootConfig || {};
const wootAPI = axios.create({ baseURL: `${apiHost}/` });

// Verificar se existe cookie de autenticação
const hasAuthCookie = () => !!Cookies.get('cw_d_session_info');
const getAuthData = () => {
  if (hasAuthCookie()) {
    const savedAuthInfo = Cookies.get('cw_d_session_info');
    return JSON.parse(savedAuthInfo || '{}');
  }
  return {};
};

// Interceptor para adicionar headers de autenticação automaticamente
wootAPI.interceptors.request.use(config => {
  if (hasAuthCookie()) {
    const {
      'access-token': accessToken,
      'token-type': tokenType,
      client,
      expiry,
      uid,
    } = getAuthData();

    config.headers['access-token'] = accessToken;
    config.headers['token-type'] = tokenType;
    config.headers['client'] = client;
    config.headers['expiry'] = expiry;
    config.headers['uid'] = uid;
  }
  return config;
});

export default wootAPI;
